import React from 'react'
import LogoOE from '../../../Img/Logo/logo_oe.png'
import LogoReabilita from '../../../Img/LandingPage/logo_reabilita.png'
import LogoCMC from '../../../Img/LandingPage/CMC_VP_COR_ESPESSO.jpg'
import './associationsStyle.css'

const Associations = () => {
  return (
    <div>
        <h2 className="projs_title">Associações Fundadoras</h2>

        <div className='association_logo_container'>
          <a href="https://www.ordemdosengenheiros.pt/regiao-centro/pt/" target="_blank" rel="noopener noreferrer">
            <img src={LogoOE} alt="Logo OE" className='association_logo' />
          </a>

          <a href="https://reabilitacoimbra.pt" target="_blank" rel="noopener noreferrer">
            <img src={LogoReabilita} alt="Logo Reabilita" className='reabilita_logo' />
          </a>

          <a href="https://www.cm-coimbra.pt" target="_blank" rel="noopener noreferrer">
            <img src={LogoCMC} alt="Logo CMC" className='cmc_logo' />
          </a>
        </div>

    </div>
  )
}

export default Associations